module.exports = __webpack_public_path__ + "img/tx_001.1c097c5f.png";